export const seoConfig = {
  siteName: '私密视频',
  siteUrl: 'https://www.simishipin.com',
  title: '私密视频 - 红桃视频西瓜视频免费高清在线看 | 小蓝视频茄子视频不缓冲',
  description: '私密视频品牌提供红桃视频、西瓜视频免费、小蓝视频等综合平台免费在线观看，高清画质不缓冲，久久视频芒果视频全集资源一站畅享。',
  keywords: '私密视频,红桃视频,西瓜视频免费,小蓝视频,茄子视频,久久视频,芒果视频,免费在线观看,高清全集,不缓冲',
  language: 'zh-CN',
  locale: 'zh_CN',
  ogImage: 'https://readdy.ai/api/search-image?query=A%20modern%20video%20streaming%20platform%20branding%20image%20with%20warm%20gradient%20background%2C%20play%20button%20icon%2C%20clean%20minimal%20design%2C%20professional%20look&width=1200&height=630&seq=og-image&orientation=landscape',
  twitterHandle: '@simishipin',
};